import React from 'react';
import './AdvAllStepCss/SelectTestStep.css';

const SelectTestsStep = ({ services, selectedTests, onTestToggle, onNext }) => {
  const handleToggle = (serviceId) => {
    onTestToggle(serviceId);
  };

  return (
    <div className="step-content">
      <h3 className="step-title">Select Tests</h3>
      <p className="step-subtitle">Choose one or more tests from the available options</p>
      
      <div className="tests-pill-container">
        {services.map((service) => (
          <button
            key={service.service_id}
            className={`test-pill ${
              selectedTests.includes(service.service_id) ? 'pill-selected' : ''
            }`}
            onClick={() => handleToggle(service.service_id)}
          >
            {service.service_name}
          </button>
        ))}
      </div>

      <div className="step-footer">
        <div className="selected-summary">
          {selectedTests.length > 0 ? (
            <span>{selectedTests.length} test(s) selected</span>
          ) : (
            <span>No tests selected</span>
          )}
        </div>
        <button
          className="btn-primary"
          disabled={selectedTests.length === 0}
          onClick={onNext}
        >
          Continue to Date & Time
        </button>
      </div>
    </div>
  );
};

export default SelectTestsStep;